import { withInstall } from '@lit-element/utils'
import TreeSelect from './src/tree-select.vue'

import type { SFCWithInstall } from '@lit-element/utils'

export const LtTreeSelect: SFCWithInstall<typeof TreeSelect> =
  withInstall(TreeSelect)

export default LtTreeSelect
